import { useTheme } from 'styled-components'

import type { DefaultProps } from './DefaultProps'
import { Wrapper } from './Wrapper'

export const HeaderIconError = ({ title, ...rest }: DefaultProps) => {
	const theme = useTheme() as any

	return (
		<Wrapper {...rest}>
			<svg viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M451.798 43.963C291.242 -53.906 41.2881 35.352 12.2041 105.911C-26.7039 200.305 38.7821 216.439 50.9471 293.785C60.7081 355.846 -0.234871 415.28 34.5531 470.067C72.4351 529.73 198.018 514.748 245.751 486.514C333.127 434.832 289.06 374.502 330.435 299.215C369.842 227.508 446.679 256.59 491.396 199.225C533.896 144.705 505.707 76.824 451.798 43.963V43.963Z'
					fill='url(#paint0_linear_26:585)'
				/>
				<path
					opacity='0.1'
					d='M455.47 452.133H56.5303C48.2463 452.133 41.5303 445.417 41.5303 437.133V122.867C41.5303 114.583 48.2463 107.867 56.5303 107.867H455.47C463.754 107.867 470.47 114.583 470.47 122.867V437.133C470.47 445.418 463.755 452.133 455.47 452.133Z'
					fill={theme.color.primary}
				/>
				<path
					d='M455.47 428.133H56.5303C48.2463 428.133 41.5303 421.417 41.5303 413.133V98.8669C41.5303 90.5829 48.2463 83.8669 56.5303 83.8669H455.47C463.754 83.8669 470.47 90.5829 470.47 98.8669V413.133C470.47 421.418 463.755 428.133 455.47 428.133Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M470.47 153.18V98.8669C470.47 90.5829 463.754 83.8669 455.47 83.8669H56.5303C48.2463 83.8669 41.5303 90.5829 41.5303 98.8669V153.18H470.47Z'
					fill={theme.color.focus}
				/>
				<path
					d='M455.47 433.133H56.5303C45.5023 433.133 36.5303 424.161 36.5303 413.133V98.8669C36.5303 87.8389 45.5023 78.8669 56.5303 78.8669H455.47C466.498 78.8669 475.47 87.8389 475.47 98.8669V413.133C475.47 424.161 466.498 433.133 455.47 433.133ZM56.5303 88.8669C51.0163 88.8669 46.5303 93.3529 46.5303 98.8669V413.133C46.5303 418.647 51.0163 423.133 56.5303 423.133H455.47C460.984 423.133 465.47 418.647 465.47 413.133V98.8669C465.47 93.3529 460.984 88.8669 455.47 88.8669H56.5303Z'
					fill={theme.color.primary}
				/>
				<path
					d='M85.6232 131.669C91.6436 131.669 96.5242 126.788 96.5242 120.768C96.5242 114.747 91.6436 109.867 85.6232 109.867C79.6027 109.867 74.7222 114.747 74.7222 120.768C74.7222 126.788 79.6027 131.669 85.6232 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M120.424 131.669C126.444 131.669 131.325 126.788 131.325 120.768C131.325 114.747 126.444 109.867 120.424 109.867C114.403 109.867 109.523 114.747 109.523 120.768C109.523 126.788 114.403 131.669 120.424 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M155.224 131.669C161.245 131.669 166.125 126.788 166.125 120.768C166.125 114.747 161.245 109.867 155.224 109.867C149.204 109.867 144.323 114.747 144.323 120.768C144.323 126.788 149.204 131.669 155.224 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M432.277 133.015H296.119V108.52H432.277C435.038 108.52 437.277 110.759 437.277 113.52V128.016C437.277 130.777 435.039 133.015 432.277 133.015V133.015Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M296.789 108.831C291.503 103.545 282.902 103.545 277.616 108.831C272.33 114.117 272.33 122.718 277.616 128.004C281.653 132.041 287.619 132.984 292.569 130.856L296.917 135.204C298.869 137.156 302.036 137.156 303.988 135.204C305.941 133.252 305.941 130.085 303.988 128.133L299.64 123.785C301.769 118.834 300.826 112.868 296.789 108.831V108.831ZM284.687 115.902C286.074 114.515 288.331 114.515 289.718 115.902C291.105 117.289 291.105 119.546 289.718 120.933C288.331 122.32 286.074 122.32 284.687 120.933C283.3 119.546 283.3 117.289 284.687 115.902Z'
					fill={theme.color.primary}
				/>
				<path
					d='M432.277 394.361H79.7231C76.9621 394.361 74.7231 392.122 74.7231 389.361V182.639C74.7231 179.878 76.9621 177.639 79.7231 177.639H432.278C435.039 177.639 437.278 179.878 437.278 182.639V389.36C437.277 392.122 435.039 394.361 432.277 394.361V394.361Z'
					fill={theme.color.focus}
				/>
				<path
					d='M420.378 207.142L417.204 203.968L420.378 200.794C422.33 198.842 422.33 195.675 420.378 193.723C418.425 191.771 415.259 191.771 413.307 193.723L410.133 196.897L406.959 193.723C405.006 191.771 401.84 191.771 399.888 193.723C397.935 195.675 397.935 198.842 399.888 200.794L403.062 203.968L399.888 207.142C397.935 209.094 397.935 212.26 399.888 214.213C401.84 216.166 405.007 216.166 406.959 214.213L410.133 211.039L413.307 214.213C415.26 216.165 418.426 216.165 420.378 214.213C422.331 212.261 422.331 209.095 420.378 207.142Z'
					fill={theme.color.primary}
				/>
				<path
					d='M296.566 253.625L264.615 199.418C260.747 192.855 251.254 192.855 247.385 199.418L215.434 253.625C211.505 260.291 216.311 268.703 224.049 268.703H287.951C295.689 268.702 300.495 260.291 296.566 253.625V253.625Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M256 242.759C253.239 242.759 251 240.52 251 237.759V217.678C251 214.917 253.239 212.678 256 212.678C258.761 212.678 261 214.917 261 217.678V237.759C261 240.52 258.761 242.759 256 242.759Z'
					fill={theme.color.primary}
				/>
				<path
					d='M256 258.06C258.762 258.06 261 255.821 261 253.06C261 250.299 258.762 248.06 256 248.06C253.239 248.06 251 250.299 251 253.06C251 255.821 253.239 258.06 256 258.06Z'
					fill={theme.color.primary}
				/>
				<path
					d='M136.16 363.466H375.84C378.601 363.466 380.84 365.705 380.84 368.466C380.84 371.227 378.601 373.466 375.84 373.466H136.16C133.399 373.466 131.16 371.227 131.16 368.466C131.16 365.705 133.398 363.466 136.16 363.466V363.466Z'
					fill={theme.color.primary}
				/>
				<path
					d='M155.66 343.009H356.34C359.101 343.009 361.34 345.248 361.34 348.009C361.34 350.77 359.101 353.009 356.34 353.009H155.66C152.899 353.009 150.66 350.77 150.66 348.009C150.66 345.248 152.898 343.009 155.66 343.009V343.009Z'
					fill={theme.color.primary}
				/>
				<path
					d='M155.66 290.646H356.34C359.101 290.646 361.34 292.885 361.34 295.646C361.34 298.407 359.101 300.646 356.34 300.646H155.66C152.899 300.646 150.66 298.407 150.66 295.646C150.66 292.884 152.898 290.646 155.66 290.646V290.646Z'
					fill={theme.color.primary}
				/>
				<path
					d='M187.769 311.102H155.659C152.898 311.102 150.659 313.34 150.659 316.102C150.659 318.863 152.898 321.102 155.659 321.102H187.769C190.53 321.102 192.769 318.863 192.769 316.102C192.769 313.341 190.531 311.102 187.769 311.102Z'
					fill={theme.color.primary}
				/>
				<path
					d='M211.915 316.102C211.915 318.863 214.154 321.102 216.915 321.102H356.34C359.101 321.102 361.34 318.863 361.34 316.102C361.34 313.34 359.101 311.102 356.34 311.102H216.915C214.154 311.102 211.915 313.341 211.915 316.102V316.102Z'
					fill={theme.color.primary}
				/>
				<path
					d='M211.915 62.279C204.035 62.279 197.624 55.868 197.624 47.988C197.624 40.107 204.035 33.696 211.915 33.696C219.795 33.696 226.207 40.107 226.207 47.988C226.207 55.868 219.796 62.279 211.915 62.279V62.279ZM211.915 43.696C209.549 43.696 207.624 45.622 207.624 47.988C207.624 50.354 209.549 52.279 211.915 52.279C214.281 52.279 216.207 50.354 216.207 47.988C216.207 45.622 214.282 43.696 211.915 43.696V43.696Z'
					fill={theme.color.focus}
				/>
				<path
					d='M164.18 51.522C161.419 51.522 159.18 49.284 159.18 46.522C159.18 43.213 156.489 40.522 153.18 40.522C150.419 40.522 148.18 38.284 148.18 35.522C148.18 32.76 150.419 30.522 153.18 30.522C156.489 30.522 159.18 27.831 159.18 24.522C159.18 21.76 161.419 19.522 164.18 19.522C166.941 19.522 169.18 21.76 169.18 24.522C169.18 27.831 171.871 30.522 175.18 30.522C177.941 30.522 180.18 32.76 180.18 35.522C180.18 38.284 177.941 40.522 175.18 40.522C171.871 40.522 169.18 43.213 169.18 46.522C169.18 49.283 166.941 51.522 164.18 51.522Z'
					fill={theme.color.focus}
				/>
				<path
					d='M312.848 481.24C304.968 481.24 298.556 474.829 298.556 466.948C298.556 459.068 304.967 452.657 312.848 452.657C320.728 452.657 327.139 459.068 327.139 466.948C327.139 474.829 320.728 481.24 312.848 481.24ZM312.848 462.657C310.482 462.657 308.556 464.582 308.556 466.948C308.556 469.314 310.481 471.24 312.848 471.24C315.214 471.24 317.139 469.314 317.139 466.948C317.139 464.582 315.214 462.657 312.848 462.657Z'
					fill={theme.color.focus}
				/>
				<path
					d='M360.785 473.657C358.024 473.657 355.785 471.419 355.785 468.657C355.785 465.348 353.094 462.657 349.785 462.657C347.024 462.657 344.785 460.419 344.785 457.657C344.785 454.895 347.024 452.657 349.785 452.657C353.094 452.657 355.785 449.966 355.785 446.657C355.785 443.895 358.024 441.657 360.785 441.657C363.546 441.657 365.785 443.895 365.785 446.657C365.785 449.966 368.476 452.657 371.785 452.657C374.546 452.657 376.785 454.895 376.785 457.657C376.785 460.419 374.546 462.657 371.785 462.657C368.476 462.657 365.785 465.348 365.785 468.657C365.785 471.419 363.546 473.657 360.785 473.657Z'
					fill={theme.color.focus}
				/>
				<path
					d='M80.7231 476.657C77.9621 476.657 75.7231 474.419 75.7231 471.657C75.7231 468.348 73.0321 465.657 69.7231 465.657C66.9621 465.657 64.7231 463.419 64.7231 460.657C64.7231 457.895 66.9621 455.657 69.7231 455.657C73.0321 455.657 75.7231 452.966 75.7231 449.657C75.7231 446.895 77.9621 444.657 80.7231 444.657C83.4841 444.657 85.7231 446.895 85.7231 449.657C85.7231 452.966 88.4141 455.657 91.7231 455.657C94.4841 455.657 96.7231 457.895 96.7231 460.657C96.7231 463.419 94.4841 465.657 91.7231 465.657C88.4141 465.657 85.7231 468.348 85.7231 471.657C85.7231 474.419 83.4841 476.657 80.7231 476.657Z'
					fill={theme.color.focus}
				/>
				<defs>
					<linearGradient
						id='paint0_linear_26:585'
						x1='37.4396'
						y1='126.007'
						x2='557.59'
						y2='339.207'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor={theme.color.iconGradientStart} stopOpacity='0' />
						<stop offset='1' stopColor={theme.color.iconGradientStop} />
					</linearGradient>
				</defs>
				<title>{title ?? 'Error'}</title>
			</svg>
		</Wrapper>
	)
}
